module.exports = __webpack_public_path__ + "static/media/cn-flag.5a7e4931.png";